import { render, staticRenderFns } from "./ProdGrid.vue?vue&type=template&id=6e28a101&scoped=true&lang=pug&"
import script from "./ProdGrid.vue?vue&type=script&lang=js&"
export * from "./ProdGrid.vue?vue&type=script&lang=js&"
import style0 from "./ProdGrid.vue?vue&type=style&index=0&id=6e28a101&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e28a101",
  null
  
)

export default component.exports